import { LevelDesignerComponent } from '../../level-designer/level-designer.component';
import { ToolGroup } from '../tool-group';
import { AlignmentToolBase } from './alignment-tool-base';

export class AlignTopTool extends AlignmentToolBase {
    constructor(canvas: HTMLCanvasElement, levelDesigner: LevelDesignerComponent, toolGroup: ToolGroup) {
        super(canvas, levelDesigner, toolGroup, 'assets/icons/aligntop.svg');
    }

    public override getName(): string {
        return 'Align Top';
    }

    public override getTooltip(): string {
        return 'Align elements to top';
    }

    public override onActivated(): void {
        const elements = this.levelDesigner.selectedElements;
        if (elements.length < 2) return;

        const boxes = this.getBoundingBoxes(elements);
        const topMost = Math.min(...boxes.map(b => b.box.y));

        boxes.forEach(({element, box}) => {
            const deltaY = topMost - box.y;
            if (deltaY !== 0) {
                element.move(0, deltaY);
            }
        });

        this.levelDesigner.saveState();
        this.levelDesigner.redraw();
    }

    public override onKeyPress(key: string): void {}
}

export class AlignMiddleVerticalTool extends AlignmentToolBase {
    constructor(canvas: HTMLCanvasElement, levelDesigner: LevelDesignerComponent, toolGroup: ToolGroup) {
        super(canvas, levelDesigner, toolGroup, 'assets/icons/alignmiddle.svg');
    }

    public override getName(): string {
        return 'Align Middle';
    }

    public override getTooltip(): string {
        return 'Align elements to vertical center';
    }

    public override onActivated(): void {
        const elements = this.levelDesigner.selectedElements;
        if (elements.length < 2) return;

        const boxes = this.getBoundingBoxes(elements);
        const centerY = boxes.reduce((sum, {box}) => sum + (box.y + box.height/2), 0) / boxes.length;

        boxes.forEach(({element, box}) => {
            const currentCenter = box.y + box.height/2;
            const deltaY = centerY - currentCenter;
            if (deltaY !== 0) {
                element.move(0, deltaY);
            }
        });

        this.levelDesigner.saveState();
        this.levelDesigner.redraw();
    }

    public override onKeyPress(key: string): void {}
}

export class AlignBottomTool extends AlignmentToolBase {
    constructor(canvas: HTMLCanvasElement, levelDesigner: LevelDesignerComponent, toolGroup: ToolGroup) {
        super(canvas, levelDesigner, toolGroup, 'assets/icons/alignbottom.svg');
    }

    public override getName(): string {
        return 'Align Bottom';
    }

    public override getTooltip(): string {
        return 'Align elements to bottom';
    }

    public override onActivated(): void {
        const elements = this.levelDesigner.selectedElements;
        if (elements.length < 2) return;

        const boxes = this.getBoundingBoxes(elements);
        const bottomMost = Math.max(...boxes.map(b => b.box.y + b.box.height));

        boxes.forEach(({element, box}) => {
            const deltaY = bottomMost - (box.y + box.height);
            if (deltaY !== 0) {
                element.move(0, deltaY);
            }
        });

        this.levelDesigner.saveState();
        this.levelDesigner.redraw();
    }

    public override onKeyPress(key: string): void {}
} 
